const initialState = {
  showIntercom: false,
  platform: 'browser',
  shiftsToConfirm: undefined,
  isLoadingShiftsToConfirm: undefined,
  shiftsToConfirmInitialized: undefined,
  attributeReminderToConfirm: undefined,
  attributeReminderToConfirmInitialized: undefined,
  isLoadingAttributeReminderToConfirm: undefined
}

const settings = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PLATEFORM':
      return { ...state, platform: action.platform }
    case 'SET_ACCESS_INTERCOM':
      return { ...state, showIntercom: action.showIntercom }
    case 'SET_SHIFT_TO_CONFIRM':
      return { ...state, shiftsToConfirm: action.shiftsToConfirm }
    case 'REMOVE_SHIFTS_TO_CONFIRM':
      return { ...state, shiftsToConfirm: undefined }
    case 'SET_SHIFTS_TO_CONFIRM_ALL_LOADED':
      return { ...state, isLoadingShiftsToConfirm: undefined, shiftsToConfirmInitialized: true }
    case 'SET_IS_LOADING_SHIFTS_TO_CONFIRM':
      return { ...state, isLoadingShiftsToConfirm: true }
    case 'SET_ATTRIBUTE_REMINDER_TO_CONFIRM':
      return { ...state, attributeReminderToConfirm: action.attributeReminderToConfirm }
    case 'SET_ATTRIBUTE_REMINDER_TO_CONFIRM_ALL_LOADED':
      return { ...state, isLoadingAttributeReminderToConfirm: undefined, attributeReminderToConfirmInitialized: true }
    case 'SET_IS_LOADING_ATTRIBUTE_REMINDER_TO_CONFIRM':
      return { ...state, isLoadingAttributeReminderToConfirm: true }
    case 'REMOVE_ATTRIBUTE_REMINDER_TO_CONFIRM':
      return { ...state, attributeReminderToConfirm: undefined }
    case 'SET_LOGGED_OUT':
      return { ...initialState }

    default:
      return state
  }
}

export default settings
